import type {
  TestHotspotElementValue,
  TestKeyboardInputElementValue,
  TestMatchingElementValue,
  TestMultipleChoiceElementValue,
  TestRankingElementValue,
  TestSingleChoiceElementValue,
} from '@vedalib/editor/lib/elements'
import type { FeedbackRTValue } from '@vedalib/editor/lib/elements'
import * as R from 'ramda'

type ChoiceElementValue = TestMultipleChoiceElementValue | TestSingleChoiceElementValue
type OnChangeFn<T extends ChoiceElementValue> = ((value: T) => void) | undefined

export const getFeedbackValue = (
  value:
    | TestMultipleChoiceElementValue
    | TestSingleChoiceElementValue
    | TestMatchingElementValue
    | TestKeyboardInputElementValue
    | TestRankingElementValue
    | TestHotspotElementValue,
) => {
  const {
    displayFeedback,
    displayOption,
    feedback,
    optionTypeFb,
    generalTypeFb,
    answerFeedback,
    generalFeedback,
  } = value

  return {
    displayFeedback,
    displayOption,
    feedback,
    optionTypeFb,
    generalTypeFb,
    answerFeedback,
    generalFeedback,
  }
}

export const onChangeRTOptionFb =
  <T extends ChoiceElementValue>(index: number, value: T, onChange: OnChangeFn<T>) =>
  (newFeedbackValue: FeedbackRTValue) => {
    const newItems = R.adjust(
      index,
      (item) => ({
        ...item,
        feedback: newFeedbackValue,
      }),
      value.items,
    )

    onChange?.({ ...value, items: newItems } as T)
  }

export const onChangeRTGeneralFb =
  <T extends ChoiceElementValue>(value: T, onChange: OnChangeFn<T>) =>
  (newFeedbackValue: FeedbackRTValue) => {
    onChange?.({ ...value, generalFeedback: newFeedbackValue } as T)
  }
